var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "134", height: "76", viewBox: "0 0 134 76", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "title",
      null,
      "DeliverableThumb"
    ),
    React.createElement(
      "g",
      { fill: "none", fillRule: "evenodd" },
      React.createElement("path", { d: "M4 0h126a4 4 0 0 1 4 4v67.856a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z", fill: "#D8D8D8" }),
      React.createElement(
        "g",
        { fill: "#FFF" },
        React.createElement("path", { d: "M71.053 47H69l2.055 9.368c.103.464.528.72.918.605l.482-.143c.4-.117.622-.616.52-1.067-.64-2.92-1.28-5.841-1.922-8.763zM61.024 55.763c-.1.451.12.95.52 1.067l.482.143c.388.115.818-.141.919-.605L65 47.002 62.946 47l-1.922 8.763zM46 18v28h42V18z" })
      )
    )
  );
});